import { useAuth } from "@/core/components/auth/store/auth";
import { Badge } from "@/core/components/ui/badge";
import { Button } from "@/core/components/ui/button";
import { MemberFilter } from "@/dashboard/components/dashboard-filters/components/member-filter";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { FilterIcon } from "lucide-react";
import { useState } from "react";
import { DashboardFiltersSheet } from "../dashboard-filters-sheet";
import { DateQuickFilters } from "./components/date-filters/components/date-quick-filters";
import { SpaceTypeFilter } from "./components/space-type-filter";
import { useTranslation } from "react-i18next";

interface DashboardFiltersProps {
  withDefaultFilters?: boolean;
  filterButtonLabel?: string;
}

export function DashboardFilters({
  withDefaultFilters = true,
  filterButtonLabel,
}: DashboardFiltersProps) {
  const [translate] = useTranslation(["dashboard"]);
  const [isFiltersSheetOpen, setIsFiltersSheetOpen] = useState(false);
  const { filterCount } = useDashboardFilters();
  const {
    userInfo: { user },
  } = useAuth();

  return (
    <div className="@container flex gap-4 items-end">
      {withDefaultFilters && (
        /*
         * Grid responsivo por container:
         * < 580px  → 1 coluna (tudo empilhado)
         * 580-840px → 2 colunas: [Data auto | Colaboradores+Tipos empilhados]
         * > 840px  → 3 colunas: [Data auto | Colaboradores | Tipos]
         *
         * O Date usa row-span-2 na faixa de 2 colunas para ocupar
         * o mesmo espaço vertical que os dois filtros ao lado.
         */
        <div className="flex flex-wrap gap-2 items-end">
          <DateQuickFilters
            event="DASHBOARD_USE_FILTER_DATE"
            eventCategory="DASHBOARD"
            className="@[580px]:row-span-2 @[840px]:row-span-1"
          />

          {user && <MemberFilter location="dashboard" />}

          <SpaceTypeFilter location="dashboard" />
          <Button
            variant="secondary"
            onClick={() => setIsFiltersSheetOpen(true)}
          >
            <FilterIcon className="mr-2 w-4 h-4" />
            {filterButtonLabel ??
              translate("dashboard-filters-button-label-default")}
            {filterCount > 0 && (
              <Badge className="flex justify-center items-center px-0 ml-2 w-5 h-5">
                {filterCount}
              </Badge>
            )}
          </Button>
        </div>
      )}

      <DashboardFiltersSheet
        open={isFiltersSheetOpen}
        onOpenChange={setIsFiltersSheetOpen}
      />
    </div>
  );
}
